import React from 'react';
import MoreDetailsButton from '../../common/MoreDetailsButton';
import JoinButton from '../../common/JoinButton';
import { CardActions } from '../../common/Card';
import { isJoinButtonAvailable } from '../../helpers';

export default ({ className = '', leaderboardId, joined, registrationStatus, participantsCount, maxParticipantsCount }) => (
    <CardActions className={className}>
        <MoreDetailsButton leaderboardId={leaderboardId} />
        {isJoinButtonAvailable({ joined, registrationStatus })
            && <JoinButton {...{
                joined,
                registrationStatus,
                leaderboardId,
                participantsCount,
                maxParticipantsCount }} />}
    </CardActions>
);
